import PropTypes from 'prop-types';
import React from 'react';

import { PRIMARY_BLUE } from '@wetransfer/transfer/constant/colors';

const Valid = ({ className, color }) => (
  <svg className={className} viewBox="0 0 13 13">
    <path
      stroke={color}
      strokeWidth="2.057"
      d="M3 6.888L6.16 10.2 11 3"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Valid.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Valid.defaultProps = {
  color: PRIMARY_BLUE,
};

export default Valid;
